import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Container, Grid, Modal, GridRow, GridColumn, Form, Dropdown, Input } from "semantic-ui-react";
import { toast } from "react-toastify";
import DatePicker from "react-datepicker";
import moment from "moment";
import cx from "classnames";

import {
  updateAccountInvitation,
  updateAccountSubscription,
  updateAccountTrail,
} from "actions/accounts";

import styles from "./subscription.module.scss";
import SaveChanges from "components/ui/Buttons/SaveButton";
import Cancel from "components/ui/Buttons/CancelButton";
import ConfirmModal from "components/ui/ConfirmModal";
import _ from 'lodash';
import { updateContract } from "actions/contract";
import { useParams } from "react-router-dom";
import { fetchLicenceCount } from "actions/accounts";
import Users from "components/features/User/Management/List/Users";
import { event } from "jquery";

export default function AccountSubscription({
  subscriptionDisabled,
  extendTrialOrInvitationDisbaled,
  account,
}) {
  const dispatch = useDispatch();

  const changeSubscription = useSelector(
    (state) => state.accounts.changeSubscription
  );

  const [initialRender, setInitialRender] = useState(true);

  const [type, setType] = useState("");
  const [changeType, setChangeType] = useState("");

  const [open, setOpen] = useState(false);

  const [createdDate, setCreatedDate] = useState("");
  const [createdDateStr, setCreatedDateStr] = useState("");

  const [trialDate, setTrialDate] = useState("");
  const [trialDateStr, setTrialDateStr] = useState("");

  const [trialDaysLeft, setTrialDaysLeft] = useState(0);

  const [invitationLimit, setInvitationLimit] = useState(0);
  const [contractTerm, setContractTerm] = useState('');
  const [selectedDate, setSelectedDate] = useState("");
  const [disableSave, setDisableSave] = useState(true);
  const [previousContractTerm, setPreviousContractTerm] = useState('');
  const [previousSelectedDate, setPreviousSelectedDate] = useState('');
  const contractDuration = useSelector((state) => _.get(state, 'accounts.contractTerm'));
  const paidDate = useSelector((state) => _.get(state,'accounts.account.subscription.changedDate'));
  const initialDate = moment(paidDate);
  const newDate = initialDate.add(1, 'days');
  const updatedDate = newDate.valueOf();
  const params = useParams();

  useEffect(() => {
    if (account && account.subscription) {
      setType(account.subscription.type);

      let noOfDays = account.subscription.noOfDays;


      var createdDateStr = null;

      if (account.subscription.changedDate != null) {
        createdDateStr = moment.utc(account.subscription.changedDate).format("YYYY-MM-DD");
      }
      else {
        createdDateStr = moment.utc(account.createdDate).format("YYYY-MM-DD");
      }

      let trialEndDate = moment(createdDateStr)
        .add(noOfDays, "days")
        .startOf("day")
        .toDate();
      let trialDateStr = moment(trialEndDate).format("YYYY-MM-DD");

      let invitation = account.subscription.invitationLimit;

      setInvitationLimit(invitation);

      let today = moment().startOf("day")
        .toDate()

      setCreatedDate(today);
      setCreatedDateStr(createdDateStr);

      setTrialDate(trialDate);
      setTrialDateStr(trialDateStr);

      let days = moment(trialDate).diff(moment().startOf("day"), "days");
      if (days > 0) {
        setTrialDaysLeft(days);
      } else {
        setTrialDaysLeft(0);
      }
    }
    setContractTerm(_.get(account, "contractTerm.contractTerm"));
    setSelectedDate(_.get(account, "contractTerm.endDate"));
    setPreviousContractTerm(_.get(account, "contractTerm.contractTerm"))
    setPreviousSelectedDate(_.get(account, "contractTerm.endDate"))
  }, [account]);

  useEffect(() => {
    if (!initialRender && !changeSubscription.updating) {
      if (changeSubscription.success) {
        toast.success(`${account.name} subscription updated`);
      } else {
        toast.error(`failed to update ${account.name} subscription`);
      }
    }
  }, [changeSubscription]);
  
  useEffect(() => {
    if (!initialRender && !changeSubscription.updating) {
      if (changeSubscription.success) {
        // toast.success(
        //   `${account.name} trial period extended up to ${trialDateStr}`
        // );

        if (createdDate && trialDate) {
          let days = moment(trialDate).diff(moment().startOf("day"), "days");
          if (days > 0) {
            setTrialDaysLeft(days);
          } else {
            setTrialDaysLeft(0);
          }
        }
      } else {
        toast.error(`failed to exted trial period for  ${account.name}`);
      }
    }
  }, [changeSubscription]);

  // useEffect(() => {
  //   if (!initialRender && !changeSubscription.updating) {
  //     if (changeSubscription.success) {
  //       toast.success(
  //         `${account.name} invitation extended to ${invitationLimit}`
  //       );
  //     } else {
  //       toast.error(`failed to exted invitation for  ${account.name}`);
  //     }
  //   }
  // }, [changeSubscription]);


  const handleInvitation = () => {
    if (!initialRender && invitationLimit) {
      dispatch(
        updateAccountSubscription({
          id: account.id,
          subscription: { invitationLimit: invitationLimit },
        })
      );
    }
  };

  setTimeout(() => {
    setInitialRender(false);
  }, 3000);

  const onSetTrialDate = (date) => {
    setTrialDate(date);

    let trialDateStr = moment(date).format("YYYY-MM-DD");
    setTrialDateStr(trialDateStr);

    if (trialDateStr) {
      dispatch(
        updateAccountSubscription({
          id: account.id,
          subscription: { trailDate: trialDateStr },
        })
      );
      setOpen(false);
    }

  };

  const onSetChangeType = (type) => {
    setChangeType(type);
    setOpen(true);
    setContractTerm('');
    setSelectedDate('')
  };

  const onSubscriptionChangeConfirm = () => {
    dispatch(
      updateAccountSubscription({
        id: account.id,
        subscription: { type: changeType },
      })
    );
    setOpen(false);
  };

  const onSubscriptionChangeCancel = () => {
    setChangeType("");
    setOpen(false);
  };

  const getSubscriptionContainer = () => {
    let style = styles.subscription;
    if (account && account.subscription) {
      if (account.subscription.type === "TRIAL") {
        style += " " + styles.trial;
      } else if (account.subscription.type === "PAID") {
        style += " " + styles.paid;
      } else if (account.subscription.type === "SUSPENDED") {
        style += " " + styles.suspended;
      } else if (account.subscription.type === "TERMINATED") {
        style += " " + styles.terminated;
      }
    }

    return style;
  };

  const getSubscriptionTypeStyle = () => {
    if (account && account.subscription) {
      if (account.subscription.type === "TRIAL") return styles.trial;
      else if (account.subscription.type === "PAID") return styles.paid;
      else if (account.subscription.type === "SUSPENDED")
        return styles.suspended;
      else if (account.subscription.type === "TERMINATED")
        return styles.terminated;
    }
  };

  const getSubscriptionTypeBtnStyle = () => {
    let style = styles.btn;
    if (account && account.subscription) {
      if (account.subscription.type === "TRIAL") {
        style += " " + styles.trial;
      } else if (account.subscription.type === "PAID") {
        style += " " + styles.paid;
      } else if (account.subscription.type === "SUSPENDED") {
        style += " " + styles.suspended;
      } else if (account.subscription.type === "TERMINATED") {
        style += " " + styles.terminated;
      }
    }

    return style;
  };

  const handleInvitationChange = (e) => {
    setInvitationLimit(e.target.value < 0 ? 0 : e.target.value);
  };


  const options = [
    { key: 'monthly', text: 'Monthly', value: 'Monthly' },
    { key: 'quarterly', text: 'Quarterly', value: 'Quarterly' },
    { key: 'half-yearly', text: 'Half-yearly', value: 'Half-yearly' },
    { key: 'annual', text: 'Annual', value: 'Annual' },
  ];

  const handleContractTermChange = (e, { value }) => {

    
    setContractTerm(value);
    setDisableSave(false);

  };


  const handleDateChange = (date) => {

    setPreviousSelectedDate(selectedDate);
    setSelectedDate(date);
    setDisableSave(false);
  };

  const handleContractClick = () => {

    let endDateString = moment(selectedDate).format("DD-MM-YYYY");
    dispatch(
      updateContract(
        {
          id: account.id, contractTerm: contractTerm, endDateStr: endDateString,

        }
      )
    )
    setDisableSave(true);
  }

  const handleReset = () => {
    
    setDisableSave(true)
    
    if(previousContractTerm){
      setContractTerm(previousContractTerm);
    }
    else{
      setContractTerm("")
    }
    setSelectedDate(previousSelectedDate);
   

  }

  useEffect(() => {
    if (!initialRender && !contractDuration.updating) {
      if (contractDuration.success) {
        toast.success(`${account.name} sucessfully updated`);
      } else {
        toast.error(`failed to update ${account.name}`);
      }
    }
  }, [contractDuration]);


  return (
    <>

      <Container className={styles.container}>
        <div className={cx(styles.title)}>Subscription</div>
        <div className={cx(styles.changedDate)}>
          <>Start: {account &&
            account.subscription &&
            account.subscription.changedDate ? (
            moment(account.subscription.changedDate).format("DD-MMM-YYYY")) : (
            moment(_.get(account, "createdDate")).format("DD-MM-YYYY")
          )}
          </>
        </div>
        < br/>
        <Grid.Row className={styles.detailsRow}>
    </Grid.Row>
        <Container className={cx(getSubscriptionContainer())}>
          <Grid>
            <Grid.Row className={styles.subscriptionTypeRow}>
              <Grid.Column width={10}>
                <div className={cx(styles.text)}> Current Subscription </div>
              </Grid.Column>
              <Grid.Column className={cx(styles.type)}>
                <span className={cx(getSubscriptionTypeStyle())}>
                  {account && account.subscription
                    ? account.subscription.type
                    : ""}
                </span>
                {account &&
                  account.subscription &&
                  account.subscription.type === "TRIAL" && (
                    <span className={cx(styles.days)}>
                      {trialDaysLeft} days left
                    </span>
                  )}
              </Grid.Column>
            </Grid.Row>

            {account &&
              account.subscription &&
              (account.subscription.type === "TRIAL" || account.subscription.type === "SUSPENDED" || account.subscription.type === "TERMINATED") && (
                <>
                  <Grid.Row className={styles.subscriptionTypeRow}>
                    <Grid.Column width={10}>
                      <span className={cx(styles.text)}>
                        Extend{" "}
                        <span>
                          {account.subscription.type === "TRIAL"
                            ? "Trial"
                            : account.subscription.type === "SUSPENDED"
                              ? "Suspended"
                              : account.subscription.type === "TERMINATED"
                                ? "Terminated"
                                : "Unknown"}
                        </span>{" "}
                        Upto
                      </span>
                    </Grid.Column>
                    <Grid.Column className={cx(styles.dateCol)}>
                      <DatePicker
                        selected={trialDate}
                        minDate={createdDate}
                        onChange={onSetTrialDate}
                        className={cx(styles.date, {
                          [styles.disabledPointer]:
                            account?.subscription?.type === "TRIAL" && extendTrialOrInvitationDisbaled,
                        })}
                        dateFormat={"dd-MMM-yyyy"}
                        disabled={
                          account?.subscription?.type === "TRIAL" && extendTrialOrInvitationDisbaled
                        }
                        showYearDropdown={true}
                        onKeyDown={(e) => {
                          e.preventDefault();
                        }}
                      />
                    </Grid.Column>
                  </Grid.Row>
                </>
              )}
            {account &&
              account.subscription &&
              account.subscription.type === "TRIAL" && (

                <>
                  <Grid.Row className={styles.subscriptionTypeRow}>
                    <Grid.Column width={10}>
                      <span className={cx(styles.text)}>
                        Extend Invitation Limit
                      </span>
                    </Grid.Column>
                    <Grid.Column className={cx(styles.dateCol)}>
                      <input
                        type="number"
                        min="0"
                        className={cx(styles.invitation, {
                          [styles.disabledPointer]: extendTrialOrInvitationDisbaled,
                        })}
                        value={invitationLimit}
                        onChange={handleInvitationChange}
                        onBlur={handleInvitation}
                        disabled={extendTrialOrInvitationDisbaled}
                      />
                    </Grid.Column>
                  </Grid.Row>
                </>
              )}
          </Grid>
        </Container>

        {account &&
          account.subscription &&
          account.subscription.type !== "TERMINATED" && (
            <>
              <Container className={cx(styles.action)}>
                <div className={cx(styles.subTitle)}>
                  Change Subscription to
                </div>
                <Grid>
                  <Grid.Row>
                    <Grid.Column>
                      {account &&
                        account.subscription &&
                        account.subscription.type === "SUSPENDED" && (
                          <>
                            <Button
                              className={cx(styles.btn, styles.trial)}
                              onClick={() => onSetChangeType("TRIAL")}
                              disabled={subscriptionDisabled}
                            >
                              <span className={cx(styles.text)}> Trial </span>
                            </Button>
                          </>
                        )}

                      {account &&
                        account.subscription &&
                        (account.subscription.type === "TRIAL" ||
                          account.subscription.type === "SUSPENDED") && (
                          <>
                            <Button
                              className={cx(styles.btn, styles.paid)}
                              onClick={() => onSetChangeType("PAID")}
                              disabled={subscriptionDisabled}
                            >
                              <span className={cx(styles.text)}> Paid </span>
                            </Button>
                          </>
                        )}

                      {account &&
                        account.subscription &&
                        (account.subscription.type === "TRIAL" ||
                          account.subscription.type === "PAID") && (
                          <>
                            <Button
                              className={cx(styles.btn, styles.suspended)}
                              onClick={() => onSetChangeType("SUSPENDED")}
                              disabled={subscriptionDisabled}
                            >
                              <span className={cx(styles.text)}> Suspend </span>
                            </Button>
                          </>
                        )}

                      {account &&
                        account.subscription &&
                        (account.subscription.type === "TRIAL" ||
                          account.subscription.type === "PAID" ||
                          account.subscription.type === "SUSPENDED") && (
                          <>
                            <Button
                              className={cx(styles.btn, styles.terminated)}
                              onClick={() => onSetChangeType("TERMINATED")}
                              disabled={subscriptionDisabled}
                            >
                              <span className={cx(styles.text)}>
                                {" "}
                                Terminate{" "}
                              </span>
                            </Button>
                          </>
                        )}
                    </Grid.Column>
                  </Grid.Row>
                  {_.get(account, 'subscription.type') === 'PAID' ? (

                    <>
                      <GridRow columns={2}>
                        <GridColumn>
                          <Form.Field>
                            <label className={cx(styles.contractTerms)}>Contract Term</label>
                            <Dropdown className={cx(styles.contractDropDown)}
                              placeholder="select a term"
                              selection
                              options={options}
                              value={contractTerm}
                              onChange={handleContractTermChange}
                            />
                          </Form.Field>
                        </GridColumn>
                        <GridColumn>
                          <Form.Field>
                            <label className={cx(styles.contractTerms)}>End Date</label>
                            <DatePicker
                              selected={selectedDate}
                              onChange={handleDateChange}
                              placeholderText="dd-mm-yyyy"
                              className={styles.randomDate}
                              showYearDropdown={true}
                              dateFormat="dd-MM-yyyy"
                              minDate={updatedDate}
                              onKeyDown={(e) => {
                                e.preventDefault();
                              }}
                            />
                          </Form.Field>
                        </GridColumn>
                      </GridRow>
                      <Grid className={cx(styles.saveReset)}>
                        <Button onClick={() => handleContractClick()} className={cx(styles.savingButton)} disabled={disableSave}>Save Changes</Button>
                        <Button onClick={() => handleReset()} className={cx(styles.resetButton)}>Reset</Button>
                      </Grid>
                    </>
                  ) : null}
                </Grid>
              </Container>
            </>
          )}

        <ConfirmModal
          open={open}
          setOpen={setOpen}
          content={`Are you sure want to move this this account to ${changeType.toLowerCase()}?`}
          onSave={onSubscriptionChangeConfirm}
          onCancel={onSubscriptionChangeCancel}
        />
      </Container>
    </>
  );
}
